import { ISwanIncomingPayment } from "./swanIncomingPaymentsQuery";

export const getAmountRemaining =  (s: ISwanIncomingPayment): number =>
    s.archivedDateTime !== null || s.noMatchDateTime !== null
        ? 0
        : s.creditedAmount - s.matchedAmount;
    